module.exports = {"130731100":"涿鹿镇","130731101":"张家堡镇","130731102":"武家沟镇","130731103":"五堡镇","130731104":"保岱镇","130731105":"矾山镇","130731106":"大堡镇","130731107":"河东镇","130731108":"东小庄镇","130731109":"辉耀镇","130731110":"大河南镇","130731111":"温泉屯镇","130731112":"蟒石口镇","130731201":"栾庄乡","130731204":"黑山寺乡","130731205":"卧佛寺乡","130731206":"谢家堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130731.json
// module id = 176
// module chunks = 0